import {put, select} from 'redux-saga/effects';
import {ViewerInfo} from '../../../../../../graphql/generated/types';
import {AppState} from '../../../../../../state/store';
import {TextViewerViewData} from '../state/TextViewerViewData.interface';
import {setCurrentChapterId, setCurrentRate} from '../state/textViewerSlice';
import {ViewerInfoState} from '../state/ViewerInfoState.interface';

export function* restoreLastViewInfo({
  productId,
  viewerInfoData,
}: {
  productId: number;
  viewerInfoData: ViewerInfo;
}) {
  const {
    viewerInfo,
    viewData,
  }: {viewerInfo: ViewerInfoState; viewData: TextViewerViewData | undefined} =
    yield select((state: AppState) => ({
      viewerInfo: state.viewerInfo,
      viewData: state.textViewer.viewData[productId],
    }));
  const {isFromPrevProduct} = viewerInfo;
  const lastViewInfo = viewerInfoData.item?.serviceProperty?.lastViewInfo;

  const fixedLastViewInfo = isFromPrevProduct
    ? {
        ...lastViewInfo,
        spineIndex: 0,
        rate: 0,
      }
    : lastViewInfo;

  yield put(
    setCurrentChapterId({
      productId,
      chapterId:
        fixedLastViewInfo?.spineIndex || viewData?.currentChapterId || 0,
    })
  );
  yield put(
    setCurrentRate({
      productId,
      rate: fixedLastViewInfo?.rate || viewData?.currentRate || 0,
    })
  );
}
